<template>
  <div class="flex min-h-screen w-full">
    <!-- Left Branding Panel -->
    <div
      class="hidden lg:flex lg:w-[45%] xl:w-[50%] flex-col items-center justify-center relative overflow-hidden login-brand-panel"
    >
      <div class="absolute inset-0 pointer-events-none">
        <div class="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-white/5"></div>
        <div class="absolute top-1/3 -right-16 w-64 h-64 rounded-full bg-white/5"></div>
        <div class="absolute -bottom-12 left-1/4 w-80 h-80 rounded-full bg-white/5"></div>
      </div>
      <div class="relative z-10 text-center px-12">
        <div class="mb-8">
          <InlineSvg :src="IrisIconReverse" width="72" height="72" class="mx-auto" />
        </div>
        <h1 class="text-white text-3xl xl:text-4xl font-bold mb-3 tracking-tight">Welcome to IRIS</h1>
        <p class="text-white/60 text-base xl:text-lg max-w-sm mx-auto leading-relaxed">
          Your comprehensive platform for client relationship management and financial services.
        </p>
      </div>
    </div>
    <!-- Right Form Panel -->
    <div class="flex-1 flex items-center justify-center min-h-screen px-4 auth-right-panel">
      <router-view v-slot="{ Component }">
        <transition name="auth-slide" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import IrisIconReverse from '@/assets/svg/iris_logo_new.svg'

export default {
  name: 'Login',
  setup() {
    return {
      IrisIconReverse,
    }
  },
}
</script>

<style lang="css" scoped>
.login-brand-panel {
  background: linear-gradient(135deg, #073763 0%, #0a4d87 50%, #0e5ea0 100%);
}

.auth-right-panel {
  background: radial-gradient(ellipse at center, #ffffff 0%, #f1f5f9 100%);
}

.auth-slide-enter-active,
.auth-slide-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.auth-slide-enter-from {
  opacity: 0;
  transform: translateY(16px);
}

.auth-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
